import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import SimpleCurrencyInput from '../../../../app/common/SimpleCurrency';
export var CurrencyOrPercentageInput = function (_a) {
    var form = _a.form, fieldName = _a.fieldName, currencySymbol = _a.currencySymbol, placeholder = _a.placeholder, disabled = _a.disabled, error = _a.error, type = _a.type;
    return (_jsxs("div", { className: "u-position-relative", children: [_jsx("div", { className: "c-prefix u-inline-block", children: type === 'fixed' ? currencySymbol : '%' }), _jsx(Controller, { control: form.control, name: fieldName, render: function (_a) {
                    var field = _a.field;
                    return (_jsx(SimpleCurrencyInput, { className: "c-input c-input--prepend", name: fieldName, value: field.value || '', onInputChange: function (value) {
                            field.onChange({
                                target: {
                                    value: value,
                                },
                            });
                        }, onInputBlur: field.onBlur, disabled: disabled, placeholder: placeholder, precision: type === 'percentage' ? 0 : 2, separator: type === 'percentage' ? '' : '.', allowEmpty: true }));
                } }), !!error && _jsx("div", { className: "c-input-error-message", children: error })] }));
};
